import { CAR_IMAGES, type CarImage } from '../mappings/carImages';
import { findBrandKey, findModelKey } from './carKeys';

/** Looks up the gallery photos for a make/model display name (e.g. "BMW", "M3"). Empty if we have none. */
export function getCarImages(make: string, model: string): CarImage[] {
  const brandKey = findBrandKey(make);
  if (!brandKey) {
    return [];
  }

  const modelKey = findModelKey(brandKey, model);
  if (!modelKey) {
    return [];
  }

  return CAR_IMAGES[brandKey]?.[modelKey] ?? [];
}
